module.exports = __webpack_public_path__ + "static/BG-blob-fd2df01b6fddd6c6f1107898a3caeaad.png";